import { Z_INDEX } from '../../../foundations/zIndex';
import { TableBodyVariantType, TableCaptionVariantType, TableCellVariantType, TableHeadVariantType, TableRowVariantTypeV2, TableVariantType, } from '../../variants';
import { DataTableVariantType } from '../variants';
export const getDefaultStyles = (FOUNDATIONS, FONT) => {
    return {
        [DataTableVariantType.DEFAULT]: {
            wrapper: {
                display: 'block',
                width: '100%',
                position: 'relative',
            },
            scrollableContainer: {
                width: '100%',
                overflow: 'auto',
            },
            table: {
                variant: TableVariantType.DEFAULT,
                z_index: Z_INDEX.INTERN_1,
            },
            tableCaption: {
                variant: TableCaptionVariantType.DEFAULT,
            },
            tableHead: {
                variant: TableHeadVariantType.DEFAULT,
            },
            tableHeadRow: {
                variant: TableRowVariantTypeV2.HEADER_ROW,
            },
            tableHeadCell: {
                variant: TableCellVariantType.HEADER_CELL,
            },
            tableBody: {
                variant: TableBodyVariantType.DEFAULT,
            },
            tableBodyRow: {
                variant: TableRowVariantTypeV2.BODY_ROW,
            },
            tableBodyCell: {
                variant: TableCellVariantType.BODY_CELL,
            },
            rowGroup: {
                table: {
                    variant: TableVariantType.DEFAULT,
                },
                tableCaption: {
                    variant: TableCaptionVariantType.DEFAULT,
                },
                tableHead: {
                    variant: TableHeadVariantType.DEFAULT,
                },
                tableHeadRow: {
                    variant: TableRowVariantTypeV2.HEADER_ROW,
                },
                tableHeadCell: {
                    variant: TableCellVariantType.HEADER_CELL,
                },
                tableBody: {
                    variant: TableBodyVariantType.DEFAULT,
                },
                tableBodyRow: {
                    variant: TableRowVariantTypeV2.BODY_ROW,
                },
                tableBodyCell: {
                    variant: TableCellVariantType.BODY_CELL,
                },
            },
            leftBoxShadowContainer: {
                position: 'absolute',
                top: '0',
                bottom: '0',
                width: FOUNDATIONS.size_100,
                pointer_events: 'none',
                transition: 'box-shadow 200ms',
                z_index: Z_INDEX.INTERN_2,
            },
            rightBoxShadowContainer: {
                position: 'absolute',
                top: '0',
                bottom: '0',
                width: FOUNDATIONS.size_100,
                pointer_events: 'none',
                transition: 'box-shadow 200ms',
                z_index: Z_INDEX.INTERN_2,
            },
            headBoxShadow: `0rem ${FOUNDATIONS.spacing_125} ${FOUNDATIONS.spacing_100} -${FOUNDATIONS.spacing_50} ${FOUNDATIONS.color_effect_shadow_drop_100}`,
            leftBoxShadow: `${FOUNDATIONS.color_effect_shadow_inner_50} ${FOUNDATIONS.spacing_125} -${FOUNDATIONS.spacing_25} ${FOUNDATIONS.spacing_100} -${FOUNDATIONS.spacing_50} inset`,
            rightBoxShadow: `${FOUNDATIONS.color_effect_shadow_drop_75} -${FOUNDATIONS.spacing_125} -${FOUNDATIONS.spacing_25} ${FOUNDATIONS.spacing_100} -${FOUNDATIONS.spacing_50} inset`,
        },
    };
};
//# sourceMappingURL=default.js.map